import { useEffect, type ReactNode } from 'react';
import { Spinner } from '@components/base/feedback';
import { useExtranetAuthStore } from '../auth/store';
import { LoginPage } from '../pages/LoginPage';

interface ExtranetAuthGuardProps {
  children: ReactNode;
}

/**
 * Renders the login page at any extranet URL until the user is
 * authenticated, then loads the origami user (`/extranet/auth/me`) once
 * before rendering the module (claimflow pattern). Pure chrome — not
 * registered.
 */
export function ExtranetAuthGuard({ children }: Readonly<ExtranetAuthGuardProps>) {
  const isAuthenticated = useExtranetAuthStore((state) => state.isAuthenticated);
  const user = useExtranetAuthStore((state) => state.user);
  const fetchUser = useExtranetAuthStore((state) => state.fetchUser);

  useEffect(() => {
    if (isAuthenticated && !user) {
      void fetchUser();
    }
  }, [isAuthenticated, user, fetchUser]);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (!user) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return <>{children}</>;
}
